
import axios from "@/axios-instance"
import moment from "moment"
import { defineComponent } from "vue";
// import useEmitter from '@/useEmitter'
import { emitter } from '@/main';

export default defineComponent({
  name: "kt-widget-5",
  props: {
    widgetClasses: String,
    idUser: String,
    idStudent: {String} as any,
    idAdReg: String,
  },
  data() {
    return {
      isEdit: false,
      arrComment: [] as any,
      comment: '',
      // idStudent: '',
      disableSubmit: false,
      showAllDrawer: false,
      _addCommentHandler: null as any,
      _reloadHandler: null as any,
    }
  },
  computed: {
    user() {
      let temp = window.localStorage.getItem("user")
      return temp ? JSON.parse(temp) : null
    },
    // Chỉ 5 ghi chú mới nhất hiện ở sidebar (arrComment đã sắp mới→cũ do unshift + API trả DESC)
    visibleComments() {
      return (this.arrComment as any[]).slice(0, 5)
    },
  },
  components: {
  },
  methods: {
    // Hiển thị comment gọn: bỏ marker [TIMELINE] + bỏ tên diễn viên "Name_email@domain " ở đầu
    // (diễn viên đã hiện ở header dòng trên qua item.User.fullName -> tránh trùng tên). Ghi chú tay giữ nguyên.
    formatComment(raw) {
      let c = raw || ''
      if (c.startsWith('[TIMELINE]')) {
        c = c.replace('[TIMELINE]', '').trim()
        c = c.replace(/^\S.*?_\S+@\S+\s+/, '')
      }
      return c.trim()
    },
    async changeEditComment() {
      if (this.isEdit) {
        await this.submitComment()
      }
      this.isEdit = !this.isEdit

    },
    async submitComment() {
      if (this.comment == '') {
        return
      }
      this.disableSubmit = true
      let dataComment = {
        "idUser": this.user.id,
        "idStudent": this.idStudent,
        "comment": this.comment
      }
      await axios.post(`/admission/comment`, dataComment)
        .then(({ data }) => {
          data.hhmm = moment(data.createdAt).format('HH:mm')
          data.createdAt = moment(data.createdAt).format('DD/MM/YYYY')
          this.comment = ''
          this.arrComment.unshift(data as never)
          this.disableSubmit = false
        })
        .catch(({ response }) => {
          console.log('err', response)
        });
    },
    async reloadComments() {
      await axios.get(`/admission/comment/reg/${this.idStudent}`)
        .then(({ data }) => {
          data.forEach(item => {
            item.hhmm = moment(item.createdAt).format('HH:mm')
            item.createdAt = moment(item.createdAt).format('DD/MM/YYYY')
          })
          this.arrComment = data
        })
        .catch(({ response }) => {
          console.log('err', response)
        });
    }
  },
  async mounted() {
    // Lưu handler để GỠ khi unmount -> tránh rò rỉ listener qua mỗi lần điều hướng/HMR
    // (nhiều listener cùng xử lý 1 object -> listener sau parse lại createdAt đã format -> "Invalid date").
    this._addCommentHandler = (data: any) => {
      // Phòng object đã được format sẵn (createdAt dạng DD/MM/YYYY) -> không parse lại bằng moment.
      if (!(typeof data.createdAt === 'string' && data.createdAt.includes('/'))) {
        data.hhmm = moment(data.createdAt).format('HH:mm')
        data.createdAt = moment(data.createdAt).format('DD/MM/YYYY')
      }
      this.arrComment.unshift(data as never)
    }
    emitter.on("addComment", this._addCommentHandler);
    // Nạp lại timeline khi có sự kiện "reloadComment" (vd sau khi gửi email phiếu ĐKXT -> BE đã ghi comment)
    this._reloadHandler = () => { this.reloadComments() }
    emitter.on("reloadComment", this._reloadHandler);
    setTimeout(() => { this.reloadComments() }, 0)

  },
  unmounted() {
    if (this._addCommentHandler) emitter.off("addComment", this._addCommentHandler)
    if (this._reloadHandler) emitter.off("reloadComment", this._reloadHandler)
  },
});
